export default "__VITE_ASSET__BryiH0Wz__"